export const environment = {	
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  buildVersion: require("../../package.json").version,
  environmentName: "dev",
  production: false,
  idleSecondsBeforeWarning: 600,
  idleSecondsBeforeLogout: 59,
  vigilantApiUrl: "https://dev.api.govigilant.app",
  // GeoStore (metro alert transit shapes) — must send Access-Control-Allow-Origin
  // for this app's origin; empty disables the feature.
  geographyApiUrl: "https://dev.api.govigilant.app",
  keycloakAuthority: "https://identity.govigilant.app/realms/vigilant",
  keycloakClientId: "voyager2",
  keycloakRedirectUri:window.location.origin,
  keycloakPostLogoutUri: window.location.origin + '/login',
  keycloakResponseType: "code",
  keycloakScope: "openid profile email offline_access",
  keycloakForgotPasswordURL: "https://identity.govigilant.app/realms/vigilant/login-actions/reset-credentials?client_id=voyager2",
  mapboxToken: "pk.eyJ1Ijoibmtsb25vc2tpIiwiYSI6ImNtcDMyc3RpcjBtNncyc3B2NTl5NGYzOHgifQ.ahUMDCsBqvdlMFDsBgm46g",
  mapboxStyle: "mapbox://styles/mapbox/dark-v11",
  matrixHomeserver: "https://staging.matrix.govigilant.app",
  providers: [],
};
